var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMegaphoneButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33342 5.83335L5.00008 5.83335C3.15913 5.83335 1.66675 7.32573 1.66675 9.16668C1.66675 11.0076 3.15913 12.5 5.00008 12.5M8.33342 5.83335L8.33342 12.5M8.33342 5.83335L12.4708 2.93694C13.8288 1.98638 14.5078 1.5111 15.0729 1.53583C15.5651 1.55736 16.0225 1.79552 16.3224 2.18635C16.6667 2.63518 16.6667 3.46397 16.6667 5.12156L16.6667 13.2114C16.6668 14.869 16.6668 15.6978 16.3224 16.1466C16.0225 16.5374 15.5651 16.7756 15.0729 16.7971C14.5078 16.8219 13.8288 16.3466 12.4709 15.396L8.33342 12.5M8.33342 12.5L5.00008 12.5M5.00008 12.5L7.50008 12.5001L7.50008 16.2501C7.50008 16.9405 6.94044 17.5001 6.25008 17.5001C5.55973 17.5001 5.00008 16.9405 5.00008 16.2501L5.00008 12.5ZM16.6667 6.66658L16.6667 11.6666C18.0475 11.6666 19.1667 10.5473 19.1667 9.16658C19.1667 7.78586 18.0475 6.66658 16.6667 6.66658Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMegaphoneButton);
export default ForwardRef;